import { PerformanceByVenueInsight } from 'apis/merchant-gateway/insights';
import { InfiniteTable } from 'modules/experience-core';

import { InsightResponsePaginated } from '../../../types';
import {
  PerformanceByVenueTableProps,
  PerformanceByVenueTotalItem,
  VenueTableSortableColumnIDs,
} from '../../tables/performance/PerformanceByVenueTable';

const usePerformanceByVenueTableProps = ({
  isVATEnabled,
  sort,
  setSort,
  performanceByVenueInsights,
  isInfinite,
}: {
  isVATEnabled: boolean;
  sort: InfiniteTable.SortState<VenueTableSortableColumnIDs> | undefined;
  setSort: (sort: InfiniteTable.SortState<VenueTableSortableColumnIDs> | undefined) => void;
  performanceByVenueInsights: InsightResponsePaginated<PerformanceByVenueInsight>;
  isInfinite?: boolean;
}) => {
  const ROWS_LIMIT = 5;

  const {
    data: performanceByVenueData,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
  } = performanceByVenueInsights;

  const items: PerformanceByVenueTotalItem[] =
    performanceByVenueData?.pages.reduce(
      (res, page) =>
        page.data.performance.split?.reduce((splitRes, item) => {
          if (item.total) {
            return [
              ...splitRes,
              { ...item.total, id: item.label ?? '', name: item.secondaryLabel ?? '', currency: page?.currency },
            ];
          }

          return splitRes;
        }, res) ?? res,
      [] as PerformanceByVenueTotalItem[],
    ) ?? [];

  const tableProps: PerformanceByVenueTableProps = {
    fetchingNextPage: isFetchingNextPage,
    fetchingPreviousPage: isFetchingPreviousPage,
    items,
    sort,
    handleSort: (sort: InfiniteTable.SortState<VenueTableSortableColumnIDs>) => setSort(sort),
    onFetchNextPage: hasNextPage && isInfinite ? fetchNextPage : undefined,
    onFetchPreviousPage: hasPreviousPage && isInfinite ? fetchPreviousPage : undefined,
    visibleRowsCount: isInfinite ? undefined : ROWS_LIMIT,
    isVATEnabled,
  };
  return tableProps;
};

export default usePerformanceByVenueTableProps;
